// WP15 (orgui-7): the pure decision behind WorkshopsFeatureGuard, tested as
// data (vitest runs without a DOM). Mirrors the server gate in
// functions/src/workshops/workshopCore.ts (assertWorkshopOrgAccess): a platform
// role that is NOT impersonating bypasses the flag; everyone else, including a
// platform admin in view-as-org, is judged by the org's own flag, the same way
// the sidebar decides whether to show the Workshops entry. A missing org fails
// closed. Imports nothing that reaches @/lib/firebase so the test also runs in
// the CI shape (no VITE_* env).

export type WorkshopsGate = "loading" | "open" | "not_enabled";

export const WORKSHOPS_NOT_ENABLED_COPY =
  "Workshops is not enabled for your organization. Ask your BiG representative if you expect it.";

export interface WorkshopsGateInput {
  orgLoading: boolean;
  org: { features?: Record<string, { enabled?: boolean } | undefined> | null } | null;
  realRole: string | null | undefined;
  isImpersonating: boolean;
}

export function decideWorkshopsGate(args: WorkshopsGateInput): WorkshopsGate {
  if (args.orgLoading) return "loading";
  const platform = args.realRole === "PLATFORM_OWNER" || args.realRole === "PLATFORM_ADMIN";
  if (platform && !args.isImpersonating) return "open";
  return args.org?.features?.workshops?.enabled === true ? "open" : "not_enabled";
}
